module.exports = __webpack_public_path__ + "components/flag/static/square/mg-ee7c80c44d89c1449c8343c96a0b0879.svg";